import { createContext, useState } from "react";

const QueryContext = createContext({});

export const QueryProvider = ({ children }) => {
    const [queryData, setQueryData] = useState({});

    return (
        <QueryContext.Provider value={{ queryData, setQueryData }}>
            {children}
        </QueryContext.Provider>
    )
}

export default QueryContext;